import { render } from "./CardsProductDiscount.vue?vue&type=template&id=b989d4c4&scoped=true"
import script from "./CardsProductDiscount.vue?vue&type=script&lang=js"
export * from "./CardsProductDiscount.vue?vue&type=script&lang=js"

import "./CardsProductDiscount.vue?vue&type=style&index=0&id=b989d4c4&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b989d4c4"]])

export default __exports__